// Curated country list. "All Countries" placeholder is the default.
export const COUNTRIES = [
  "United States", "United Kingdom", "Canada", "Australia", "Singapore",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Oman", "Bahrain",
  "India", "Pakistan", "Bangladesh", "Sri Lanka", "Nepal",
  "Malaysia", "Indonesia", "Thailand", "Vietnam", "Philippines",
  "Japan", "South Korea", "Hong Kong", "China",
  "Germany", "France", "Netherlands", "Switzerland", "Sweden", "Spain", "Italy", "Ireland", "Portugal",
  "Nigeria", "Kenya", "South Africa", "Egypt", "Ghana", "Rwanda",
  "Brazil", "Mexico", "Argentina", "Chile", "Colombia",
  "New Zealand",
  "Other",
];
